import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MaskLines, Icon } from "./common";
import { useLang } from "../i18n/LanguageContext";
import { IMG } from "../data/site";

export const PageHero = ({ title, sub, crumb, bg = IMG.office2 }) => {
  const { t } = useLang();
  return (
  <section className="relative overflow-hidden bg-navy grain pt-36 md:pt-44 pb-16 md:pb-24" data-testid="page-hero">
    <div className="absolute inset-0">
      <img src={bg} alt="" className="h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-navy/80 to-navy" />
      <div className="absolute inset-0" style={{ background: "radial-gradient(50% 60% at 75% 20%, rgba(30,111,224,0.3), transparent)" }} />
    </div>
    <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-8">
      <motion.nav initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="flex items-center gap-2 text-sm text-white/50">
        <Link to="/" className="hover:text-white">{t.nav.home}</Link>
        <Icon name="ChevronRight" size={14} className="rtl:rotate-180" />
        <span className="text-white/80">{crumb || title}</span>
      </motion.nav>
      <h1 className="mt-5 font-display text-4xl md:text-6xl text-white leading-[1.05] max-w-3xl">
        <MaskLines lines={[title]} />
      </h1>
      {sub && <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
        className="mt-5 max-w-xl text-lg text-white/70 leading-relaxed">{sub}</motion.p>}
    </div>
  </section>
  );
};

export default PageHero;
